export default __webpack_public_path__ + "static/logo-text-blue-f26f9bbf0f3647303155fc832f06e82e.png";